import { Component, Input, OnInit , Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import * as moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap';
import { SweetMessage } from '../../../config/sweet-message';
import { Validation } from '../../../config/validation';
import { PeriodoContable } from '../../../models/periodo-contable';
import { PeriodoContableService } from '../../../services/periodo-contable.service';
import { SessionService } from '../../../services/session.service';
@Component({
  selector: 'app-periodo-edit-modal',
  templateUrl: './periodo-edit-modal.component.html',
  styleUrls: ['./periodo-edit-modal.component.css'],
  providers: [PeriodoContableService, SessionService, FormBuilder]
})
export class PeriodoEditModalComponent implements OnInit {
  @Input() periodo_id:String;
  @Output() sendPeriodo = new EventEmitter();
  public title: String;
  public periodo: PeriodoContable;
  public periodos: Array<PeriodoContable>;
  public msg: SweetMessage;
  myForm: FormGroup;
  public vl: Validation;
  public loading: boolean;
  public fecha_inicio;
  public fecha_fin;
  public cierre_mensual: boolean;
  public is_dia_mayor:boolean;

  constructor(
    private peridoService: PeriodoContableService,
    private ss: SessionService,
    public fb: FormBuilder,
    private storage: AsyncLocalStorage,
    public bsModalRef: BsModalRef,
    public bsModalRef2: BsModalRef,
    public periodoService : PeriodoContableService

  ) {
    this.title = "Periodo contable";
    this.periodos = [];
    this.loading = false;
    this.fecha_inicio = moment(this.fecha_inicio);
    this.fecha_fin = moment(this.fecha_fin);
    this.cierre_mensual = false;
    this.is_dia_mayor = false;
  }

  ngOnInit() {
    this.onForm();
    this.msg = new SweetMessage();
    this.vl = new Validation();
    this.periodo = new PeriodoContable();
    this.setValueEntity();
    this.getPeriodoById(this.periodo_id);
    

  }

  getPeriodoById(id) {
    
    
    return new Promise((resolve, reject) => {
      
      this.periodoService.getById(id).subscribe(
        res => {
          this.periodo = res;
          this.setValueForm();
          resolve();
        },
        err => {
          this.periodo = null;
          reject();
        }
      );
    });
  }


  onSubmit() {
    this.setValueEntity();
    this.loading = true;
    this.peridoService.update(this.periodo).subscribe(
      res => {
        this.sendPeriodo.emit(this.periodo);
        this.loading = false;
        this.msg.showMessage('success-message', res.message);
        this.bsModalRef.hide();
      },
      err => {
        this.loading = false;
        this.msg.showMessage('error-message', err);
      }
    );
  }

  onForm() {
    this.myForm = this.fb.group({
      nombre: ['', [Validators.required, Validators.pattern(/[A-Za-z0-9\s]*/)]],
     
      cierre_mensual: [''],

      dia_cierre: ['', Validators.required],


    });
    this.validarCierre();
  }

  validarCierre() {
    this.myForm.get('cierre_mensual').valueChanges
      .subscribe(value => {
        if (value) {
          this.myForm.get('dia_cierre').setValidators(Validators.required)
        } else {
          this.myForm.get('dia_cierre').clearValidators();
        }
        this.myForm.get('dia_cierre').updateValueAndValidity();
      }
      );
  }

  setValueEntity() {
    this.periodo.nombre = this.myForm.controls['nombre'].value;
    this.periodo.cierre_mensual = this.myForm.controls['cierre_mensual'].value;
    if (!this.periodo.cierre_mensual) {
      this.periodo.dia_cierre = "";
    }else{
      this.periodo.dia_cierre = this.myForm.controls['dia_cierre'].value;
    }
    this.periodo.usuario_id = this.ss.getData('usuario_id');
    this.periodo.empresa_id = this.ss.getData('empresa_id');


  }

  setValueForm() {
		this.myForm.patchValue({
			nombre: this.periodo.nombre,
      cierre_mensual:this.periodo.cierre_mensual,
      dia_cierre:this.periodo.dia_cierre ? this.periodo.dia_cierre : null,
		});
	}

  isValidForm(){
    if (this.is_dia_mayor) {
      return false;
    }
		return true;
  }

  validErrorForm(campo) {
    return this.vl.validErrorForm(campo, this.myForm);
  }

  validTypeMsgForm(nombre, campo) {
    return this.vl.validTypeMsgForm(nombre, campo, this.myForm);
  }

  validarMaxNum(){
    let dia= this.myForm.controls['dia_cierre'].value;
    (dia>31)?this.is_dia_mayor = true: this.is_dia_mayor =false;
   
  }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/periodo-edit-modal/periodo-edit-modal.component.ts